/**
 * @generated SignedSource<<01648c35e37583fe86e92ac6b3ea7bc7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type tagManagerFragment$data = {
  readonly countryISOCode: string | null;
  readonly ecommerceSettings: {
    readonly currencyCode: string | null;
  } | null;
  readonly sellerIP: string | null;
  readonly treeMenuReferringInfo: {
    readonly isTrial: boolean;
    readonly noValidSubscriptionReason: string | null;
    readonly subscriptionCancel: string | null;
  };
  readonly " $fragmentType": "tagManagerFragment";
};
export type tagManagerFragment$key = {
  readonly " $data"?: tagManagerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"tagManagerFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "tagManagerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeMenuReferringInfo",
      "kind": "LinkedField",
      "name": "treeMenuReferringInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTrial",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noValidSubscriptionReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriptionCancel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryISOCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerIP",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4ffe7dee3ef78e5722bf9a292e57f8e3";

export default node;
